import { render, staticRenderFns } from "./date-slider-new.vue?vue&type=template&id=5411f2d3"
import script from "./date-slider-new.vue?vue&type=script&lang=js"
export * from "./date-slider-new.vue?vue&type=script&lang=js"
import style0 from "./date-slider-new.vue?vue&type=style&index=0&id=5411f2d3&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5411f2d3')) {
      api.createRecord('5411f2d3', component.options)
    } else {
      api.reload('5411f2d3', component.options)
    }
    module.hot.accept("./date-slider-new.vue?vue&type=template&id=5411f2d3", function () {
      api.rerender('5411f2d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/date-slider-new.vue"
export default component.exports